/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.2"
        height="67.8"
        viewBox="0 0 82.2 67.8"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M80.97 5.86a1.25 1.25 0 0 1 .13 2.49H32.73a1.25 1.25 0 0 1-.13-2.49ZM20.29 5.86a1.25 1.25 0 0 1 .17 2.49H1.22a1.25 1.25 0 0 1-.13-2.49Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M26.55 0a7.11 7.11 0 1 0 7.11 7.11A7.11 7.11 0 0 0 26.55 0Zm0 2.5a4.61 4.61 0 1 1-4.61 4.61 4.6 4.6 0 0 1 4.61-4.61Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M80.97 59.4a1.25 1.25 0 0 1 .13 2.49H32.66a1.25 1.25 0 0 1-.13-2.49ZM20.37 59.4a1.25 1.25 0 0 1 .12 2.49H1.22a1.25 1.25 0 0 1-.13-2.49ZM48.96 32.65a1.25 1.25 0 0 1 .13 2.49H1.22a1.25 1.25 0 0 1-.13-2.49ZM80.97 32.65a1.25 1.25 0 0 1 .13 2.49H61.29a1.25 1.25 0 0 1-.13-2.49Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M55.14 26.79a7.11 7.11 0 1 0 7.15 7.11 7.11 7.11 0 0 0-7.11-7.11Zm0 2.5a4.61 4.61 0 1 1-4.61 4.61 4.6 4.6 0 0 1 4.61-4.61ZM26.55 53.58a7.11 7.11 0 1 0 7.11 7.11 7.11 7.11 0 0 0-7.11-7.11Zm0 2.5a4.61 4.61 0 1 1-4.61 4.61 4.6 4.6 0 0 1 4.61-4.61Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SettingsSliderIcon';

export default Icon;
